module.exports = __webpack_public_path__ + "media/src/images/signup-a21f8a542e9c35bafba226f4f55ca1e7.png";